var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaudeCode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 -3 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3632 4.06929H16.4167V6.19114H14.3646V8.26238H13.3475V10.2604H12.3125V8.26238H11.2954V10.2604H10.2604V8.26238H6.15626V10.2604H5.12201V8.26238H4.10417V10.2604H3.06924V8.26238H2.05209V6.19046H0V4.06997H2.05209V0H14.3632V4.06929ZM4.10417 4.06929H5.12201V2.12186H4.10417V4.06929ZM11.2933 4.06929H12.3125V2.12186H11.2933V4.06929Z",
    fill: "#0082ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaudeCode);
export default __webpack_public_path__ + "static/media/claude_code.47fa8b267ccb7a6593eb95cad3e89dac.svg";
export { ForwardRef as ReactComponent };